import React from 'react';

const TelegramSafeArea = ({ children, style = {}, className = '' }) => {
    return (
        <div
            className={`telegram-safe-area ${className}`}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                minHeight: '74px',
                padding: 'var(--tg-safe-area-inset-top, 20px) 0px 0px 0px', // پشتیبانی از متغیرهای تلگرام
                boxSizing: 'border-box',
                
                // --- استایل‌های اضافه‌شده برای چسبندگی ---
                position: 'sticky',
                top: 0,
                zIndex: 100, // برای قرار گرفتن روی سایر محتوا
                backgroundColor: 'var(--tg-theme-bg-color, #ffffff)', // جلوگیری از تداخل بصری با محتوای اسکرول‌شده
                
                ...style // اضافه کردن استایل‌های داینامیک که از بیرون پاس داده می‌شود
            }}
        >
            {children}
        </div>
    );
};

export default TelegramSafeArea;
